export const DataTypes = {
  ACTIVE: 'ACTIVE',
  HISTORICAL: 'HISTORICAL',
};
